import type { BehaviorDateRangeParams, BehaviorScopeParams } from './types';

/**
 * The query a behavior range request sends. Without a fish group the params are passed on
 * without a `fishGroupId` key, so the cage request is identical to what it was before fish
 * groups existed.
 */
export function toBehaviorRangeQuery(
    params?: BehaviorDateRangeParams
): BehaviorDateRangeParams | undefined {
    if (params?.fishGroupId != null) return params;
    if (params === undefined) return undefined;

    const { fishGroupId: _absent, ...rest } = params;
    return rest;
}

/** The overview's query: nothing at all unless a fish group is named. */
export function toBehaviorScopeQuery(
    params?: BehaviorScopeParams
): BehaviorScopeParams | undefined {
    return params?.fishGroupId != null ? { fishGroupId: params.fishGroupId } : undefined;
}
